"use client";

import React, { useCallback, useEffect, useRef, useState } from 'react';
import { GlobalButtonFinal, ModalsWrapper, ModalWindow } from '../GlobalStyles';

import { faDownload, faRotateRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Cropper } from "react-cropper";
import "cropperjs/dist/cropper.css";
import { FormattedMessage } from 'react-intl';
import messages from '../../../../src/messages';
import Link from 'next/link';
import { useDropzone } from "react-dropzone";

export default function DialogEditor({
                                         toggleEditorWindow,
                                         toggleEditorWindowInsideShrinkProducts,
                                         windowEditorType,
                                         templateHeight,
                                         templateWidth,
                                         setUploadedTexture,
                                         setUploadedTextureType,
                                         toggleEditorWindowFinishUpload,
                                        downloadSketch
                                     }) {
    const [windowEditorTypeInner, setWindowEditorTypeInner] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const [editorShow, setEditorShow] = useState(false);
    const [editorTransitionShow, setEditorTransitionShow] = useState(false);

    const changeEditorShow = variable => {
        if (variable === true) {
            setEditorShow(variable);
            setTimeout(function () {
                setEditorTransitionShow(true);
            }, 1);
        } else {
            setEditorTransitionShow(false);
            setTimeout(function () {
                setEditorShow(variable);
            }, 500);
        }
    };

    const closeEditorShow = () => {
        changeEditorShow(false);
        setEditorTransitionShow(false);
        setFile(null);
        setWindowEditorTypeInner('manually');
        setErrorMessage('');
        setFile(null);
        setDraggedOver(false);

    };

    const [showEditorDialog, setShowEditorDialog] = useState(false);

    const toggleEditorInside = useCallback((): void => {
        if (showEditorDialog) {
            changeEditorShow(false);
        } else {
            changeEditorShow(true);
        }
    }, []);

    const toggleEditorWindowFinishUploadInside = useCallback((): void => {
        setFinishUpload();
    }, []);

    useEffect(() => {
        toggleEditorWindow && toggleEditorWindow(toggleEditorInside);
    }, [toggleEditorWindow, toggleEditorInside]);

    useEffect(() => {
        toggleEditorWindowFinishUpload && toggleEditorWindowFinishUpload(toggleEditorWindowFinishUploadInside);
    }, [toggleEditorWindowFinishUpload, toggleEditorWindowFinishUploadInside]);

    ////////////

    const toggleEditorWindowInsideShrinkProductsInside = useCallback((): void => {
        if (showEditorDialog) {
            changeEditorShow(false);
        } else {
            changeEditorShow(true);
        }
        setWindowEditorTypeInner('chooseInsideShrink');
    }, []);
    useEffect(() => {

        toggleEditorWindowInsideShrinkProducts && toggleEditorWindowInsideShrinkProducts(toggleEditorWindowInsideShrinkProductsInside);
    }, [toggleEditorWindowInsideShrinkProducts, toggleEditorWindowInsideShrinkProductsInside]);

    //////////
    const closeModalOutsideClick = e => {
        if (e.target.getAttribute('data-closemodal') === 'true') {
            changeEditorShow(false);
        }
    };


    useEffect(() => {
        if (windowEditorType) {
            setWindowEditorTypeInner(windowEditorType);
        }
    }, [windowEditorType]);

    const setModalShow = (variable, type, parentUUID) => {
        if (variable === true) {
            setTimeout(function () {
                setModalTransitionShow(true);
            }, 1);
        } else {
            setModalTransitionShow(false);
            setTimeout(function () {
                //setLoadProductsShowVariable(variable);
            }, 300);
        }
    };
    const setInputTeamLogoFunction = file => {
        setInputTeamLogo(file);
    };
    const [file, setFile] = useState(null);
    const [draggedOver, setDraggedOver] = useState(false);

    const [inputTeamLogo, setInputTeamLogo] = useState();

    const [modalTransitionShow, setModalTransitionShow] = useState(false);

    const handleDragOver = event => {
        event.preventDefault();
        setDraggedOver(true);
    };
    const handleDragLeave = event => {
        event.preventDefault();
        setDraggedOver(false);
    };

    const setResetUpload = () => {
        setWindowEditorTypeInner('manually');
        setErrorMessage('');
        setFile(null);
        setDraggedOver(false);
    };

    const setFinishUpload = () => {
        changeEditorShow(false);

        setTimeout(function () {
            setWindowEditorTypeInner('manually');
            setErrorMessage('');
            setFile(null);
            setDraggedOver(false);
        }, 300);
    };

    const handleDrop = event => {
        event.preventDefault();
        const droppedFiles = event.dataTransfer.files[0];

        setFile(droppedFiles);

        setDraggedOver(false);
    };


    const handleChangeTexture = (e: React.ChangeEvent<HTMLInputElement>): void => {
        setFile(e.target.files[0]);
    };
    const inputFile = useRef(null);
    const onButtonClick = () => {
        // `current` points to the mounted file input element
        inputFile.current.click();
    };



    ////////

    const [fileFinal, setFileFinal] = useState(null);
    const [cropData, setCropData] = useState(null);
    const [error, setError] = useState("");

    const [REQUIRED_WIDTH, SetREQUIRED_WIDTH] = useState(templateWidth);
    const [REQUIRED_HEIGHT, SetREQUIRED_HEIGHT] = useState(templateHeight);

    const cropperRef = useRef(null);

    const latestDimensions = useRef({ width: templateWidth, height: templateHeight });

    useEffect(() => {
        latestDimensions.current = { width: templateWidth, height: templateHeight };
        SetREQUIRED_WIDTH(templateWidth);
        SetREQUIRED_HEIGHT(templateHeight);
    }, [templateWidth, templateHeight]);

    const handleFileChange = (selectedFile) => {
        const reader = new FileReader();
console.log("handling",reader);
        reader.onload = () => {
            console.log("handling2",reader);
            const img = new Image();

            console.log("handling2",reader,img);

            img.onload = () => {
                const { width: currentWidth, height: currentHeight } = latestDimensions.current;
                console.log("inside change2", img.width, currentWidth, img.height, currentHeight);

                // Vytvoříme canvas, do kterého obrázek vykreslíme
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                // Volitelně můžete zkontrolovat rozměry a vykreslit obrázek tak, aby se vešel správně
                ctx.drawImage(img, 0, 0, img.width, img.height);

                // Převod canvasu na Blob s MIME typem "image/png"
                canvas.toBlob((blob) => {
                    if (blob) {
                        // Pokud obrázek nemá očekávané rozměry, můžete dále reagovat
                        if (img.width !== currentWidth || img.height !== currentHeight) {
                            // V tomto případě pracujte s Blobem nebo File, případně nastavte chybový stav
                            setFile(URL.createObjectURL(blob));
                            setWindowEditorTypeInner('manually');
                        } else {
                            const fileFromBlob = new File([blob], "converted.png", { type: "image/png" });
                            setUploadedTexture(fileFromBlob);
                            setFile(null);
                            setWindowEditorTypeInner('uploading-loading');
                        }
                    } else {
                        setError("Failed to convert canvas to Blob.");
                    }
                }, "image/png");
            };
            img.src = reader.result;
        };
        reader.readAsDataURL(selectedFile);
    };




    const closeDesign = () => {


        if(file){
            setResetUpload();
            setFile(null);
            setError("");
        } else {
            changeEditorShow(false)
            //setModalOpen(false);
        }

        // setModalOpen(false);
    };



    const onDrop = useCallback((acceptedFiles) => {
        if (acceptedFiles.length > 0) {
            setWindowEditorTypeInner('uploading-loading');
            handleFileChange(acceptedFiles[0]);
            console.log("accepted file", acceptedFiles[0])
        } else {
            setError("Invalid file type. Please upload a .jpg, .jpeg or .png file.");
        }
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: "image/jpeg, image/png",
        maxFiles: 1,
    });
    const handleCrop = () => {
        const cropper = cropperRef.current?.cropper;
        if (cropper) {
            const canvas = cropper.getCroppedCanvas({
                width: REQUIRED_WIDTH,
                height: REQUIRED_HEIGHT,
            });
            if (canvas) {
                setWindowEditorTypeInner('manually');
                canvas.toBlob((blob) => {
                    if (blob) {
                        // Vytvoření File objektu s MIME typem "image/png"
                        const croppedFile = new File([blob], "cropped.png", { type: "image/png" });
                        setFile(null);
                        setCropData(null);
                        setUploadedTexture(croppedFile);
                        setWindowEditorTypeInner('uploading-loading');
                    } else {
                        setError("Failed to convert canvas to Blob.");
                    }
                }, "image/png");
            } else {
                setWindowEditorTypeInner('manually');
                setError("Failed to crop the image. The canvas could not be created.");
            }
        } else {
            setWindowEditorTypeInner('manually');
            setError("Cropper is not initialized. Please ensure an image is uploaded.");
        }
    };


    return (
        <>
            <ModalsWrapper
                className={`editorCheck  ${editorTransitionShow ? 'showTransition' : 'hideTransition'} ${!editorShow ? 'hiddeComplete' : ''}`}
                data-closemodal={true}

                onClick={e => closeModalOutsideClick(e)}
            >
                <ModalWindow className={'center'} id={'editorProductDialog'} style={windowEditorTypeInner === 'uploading-loading' ? {    height: "190px",  paddingTop: "10px"} : {    paddingTop: "10px"}}>
                    <div className={'modal-header'}>
                        {windowEditorTypeInner === 'illustrator' ? <h4>
                            <FormattedMessage {...messages.modal_upload_texture_editor_illustrator_title}></FormattedMessage>
                        </h4> : null}

                        {windowEditorTypeInner === 'manually' ?
                            <h4><FormattedMessage {...messages.modal_upload_texture_editor_title}></FormattedMessage>
                            </h4> : null}

                        {windowEditorTypeInner === 'error-uploading' ? <h4 style={{ color: '#C80000' }}>
                            <FormattedMessage {...messages.modal_upload_texture_editor_error_title}></FormattedMessage>
                        </h4> : null}

                        {windowEditorTypeInner === 'uploading-loading' ? <h4>
                            <FormattedMessage {...messages.modal_upload_texture_editor_uploading_title}></FormattedMessage>
                        </h4> : null}
                    </div>



                    <div className={'modal-content shareProduct'} style={{ display: 'block' }}>
                        <>
                            {windowEditorTypeInner === 'illustrator' ? (
                                <>
                                <span> 1. <FormattedMessage {...messages.modal_texture_editor_install_plugin_1}></FormattedMessage>
                                    <a  href={"https://exchange.adobe.com/apps/cc/200493/obalero"} target={"_blank"}>
                                    Creative Cloud</a>, <FormattedMessage {...messages.modal_texture_editor_install_plugin_2}></FormattedMessage>
                                    <Link href={"/help"} target={"_blank"}>FAQ</Link>
                                    <img style={{ maxWidth: '100%' }} src={"/images/install_plugin.png"} />

                                    <Link href={"https://exchange.adobe.com/apps/cc/200493/obalero"} target={"_blank"}>
                                         <GlobalButtonFinal
                                             style={{ width: 'unset' }}
                                             className={'borderBlue btn-circle'}
                                         >
                                                <img style={{
                                                    width: "20px",
                                                    marginRight: " 7px",
                                                    top: "-2px",
                                                    position: "relative"
                                                }} src={'/images/ai.png'} />
                                        <FormattedMessage {...messages.install_plugin} ></FormattedMessage>

                                    </GlobalButtonFinal>
                                    </Link>


                                </span>
                                    <br/>

                                    <span className={"downloadAdobe"} onClick={()=> downloadSketch()} >
                                        2.   <FormattedMessage {...messages.download_paired_plugin} ></FormattedMessage> <span style={{marginTop:"5px"}}> <FontAwesomeIcon
                                        id={"downloadAdobe"}
                                        data-intercom-target="downloadAdobe"
                                        icon={faDownload}
                                        onClick={() => downloadSketch()}
                                        style={{
                                            fontSize: '14px',
                                            marginRight: '7px',
                                        }}
                                    />
                                        Illustrator Design Template</span>
                                    </span>
                                </>

                            ) : null}

                            {windowEditorTypeInner === 'manually' ? (
                                <span style={{fontSize:"17px"}}>
                                    <FormattedMessage {...messages.modal_upload_texture_editor_description}
                                                      values={{
                                                          width: `${templateWidth}`,
                                                          height: `${templateHeight}`,
                                                      }}
                                    ></FormattedMessage>
                                    <br />             <br />
                                   <i style={{ fontSize: '13px', color:"darkred" }}>
                                       <FormattedMessage {...messages.upload_texture_alert_size} ></FormattedMessage>
                                    </i>
                                </span>
                            ) : null}

                            {windowEditorTypeInner === 'error-uploading' ? <span>{errorMessage}</span> : null}

                            {windowEditorTypeInner === 'manually' ? (
                                <div
                                     style={{
                                         justifyContent: 'center',
                                         alignItems: 'stretch',
                                         borderRadius: '11px',
                                         borderColor: 'rgba(102, 102, 102, 1) !important',
                                         borderStyle: 'dashed !important',
                                         borderWidth: '1px!important',
                                         display: 'flex',
                                         marginTop: '30px',
                                         paddingBottom: '50px',
                                         flexDirection: 'column',
                                     }}
                                     className={`fileUploadEditor  ${draggedOver ? 'activeDrag' : ''}`}
                                >


                                    {!file && (<div
                                        {...getRootProps()}
                                        className={` border-dashed  p-4 mt-4 ${isDragActive ? "border-blue-500" : "border-gray-300"}`}
                                        style={{ width: "100%" }}
                                    >
                                        <input {...getInputProps()} />
                                        {isDragActive ? (
                                            <p className="text-center text-blue-500">   <FormattedMessage {...messages.upload_texture_drop_file} ></FormattedMessage></p>
                                        ) : (
                                            <>
                                                <p className="text-center">
                                                    <FormattedMessage {...messages.upload_texture_upload_file_move} ></FormattedMessage></p>
                                                <button
                                                    className="chooseFileButton"> <FormattedMessage {...messages.upload_texture_choose_file} ></FormattedMessage>
                                                </button>
                                            </>

                                        )}
                                    </div>)}

                                    {  console.log(REQUIRED_WIDTH / REQUIRED_HEIGHT, REQUIRED_WIDTH , REQUIRED_HEIGHT)}
                                    {file && (

                                        <div className="mt-4" >
                                            <Cropper
                                                src={file}
                                                style={{ height: 300, width: "100%" }}
                                                autoCropArea={1}
                                                guides={true}
                                               //  initialAspectRatio={REQUIRED_WIDTH / REQUIRED_HEIGHT}
                                                 aspectRatio={REQUIRED_WIDTH / REQUIRED_HEIGHT}
                                                cropBoxResizable={true}
                                                cropBoxMovable={true}
                                                autoCrop={true}
                                                // minCropBoxWidth={REQUIRED_WIDTH > REQUIRED_HEIGHT ? REQUIRED_WIDTH : null}
                                                //minCropBoxHeight={REQUIRED_HEIGHT > REQUIRED_WIDTH ? REQUIRED_HEIGHT : null}
                                                //  minCropBoxHeight={REQUIRED_HEIGHT}
                                                ref={cropperRef}
                                            />
                                        </div>
                                    )}

                                    {error && <div className="text-red-500 mt-4">{error}</div>}
                                </div>
                            ) : null}

                            {windowEditorTypeInner !== 'uploading-loading' ? (
                                <div className={'modal-buttons'}>


                                    <div className="flex space-x-4 mt-6">
                                        {file ?
                                            <GlobalButtonFinal
                                                className="cropButton backgroundBlue btn-circle"
                                                onClick={handleCrop}
                                                style={{    marginRight: "10px"}}
                                            >
                                                Nahrát design
                                            </GlobalButtonFinal>
                                            : null}
                                        {/*        <button
                                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                                onClick={handleUpload}
                            >
                                Upload Texture
                            </button>*/}
                                        <GlobalButtonFinal
                                            onClick={windowEditorTypeInner === 'error-uploading' ? () => setResetUpload() : () => closeEditorShow()}
                                            className=" borderBlue btn-circle">
                                            <FormattedMessage {...messages.packshots_modal_close} ></FormattedMessage>

                                        </GlobalButtonFinal>


                                    </div>

                                    {/* <GlobalButtonFinal
                                        style={{ width: 'unset' }}
                                        className={'borderBlue btn-circle'}
                                        onClick={windowEditorTypeInner === 'error-uploading' ? () => setResetUpload() : () => changeEditorShow(false)}
                                    >
                                        <FormattedMessage {...messages.modal_upload_texture_editor_button_cancel} ></FormattedMessage>

                                    </GlobalButtonFinal>*/}

                                    {windowEditorType === 'error-uploading' ? (
                                        <GlobalButtonFinal style={{ width: 'unset' }}
                                                           className={'borderBlue btn-circle'}
                                                           onClick={() => changeEditorShow(false)}>
                                            <FontAwesomeIcon
                                                icon={faRotateRight} /><FormattedMessage {...messages.modal_upload_texture_editor_button_try_again} ></FormattedMessage>
                                        </GlobalButtonFinal>
                                    ) : null}
                                </div>
                            ) : null}

                            {windowEditorTypeInner === 'uploading-loading' ? (
                                <div className={'uploading-loading'}>
                                    <img src={'/logoAnimate.svg'} />
                                </div>
                            ) : null}
                        </>
                    </div>
                </ModalWindow>
            </ModalsWrapper>
        </>
    );
}
